import { useTheme } from '../contexts/ThemeContext';
import { useFont } from '../contexts/FontContext';
import BackButton from '../components/BackButton';
import { useEffect } from 'react';

export default function PrivacyPolicy() {
  const { theme } = useTheme();
  const { font } = useFont();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: font.family }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <BackButton />
        </div>

        <div className="bg-white rounded-xl shadow-sm p-8">
          <h1 className={`text-3xl font-bold text-${theme.text} mb-8`}>
            Politique de confidentialité
          </h1>

          <div className="prose max-w-none">
            <p className="text-sm text-gray-500 mb-8">
              Site : loustaletformation.fr – Mise à jour : 20 avril 2025
            </p>

            <p className="text-gray-600 mb-8">
              La présente politique explique comment Loustalet formation (Statut entreprise EURL L'oustalet, Conseils et Formations : , SIRET 893 608 976 00013, ci‑après « nous ») traite les données personnelles des visiteurs et clients (« vous ») lorsqu'ils consultent le site ou achètent nos formations en ligne.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Qui est responsable du traitement ?</h2>
            <p className="text-gray-600 mb-4">
              Loustalet formation – 45 rue haute saint paterne, 36100 ISSOUDUN – contact : <a href="mailto:loustaletformation@gmail.com" className="text-rose-500 hover:text-rose-600">loustaletformation@gmail.com</a>.<br/>
              Aucun délégué à la protection des données (DPO) n'est désigné compte tenu de la taille et de la nature de nos traitements.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Quelles données collectons‑nous ?</h2>
            <div className="overflow-x-auto mb-8">
              <table className="w-full">
                <thead>
                  <tr className="border-b">
                    <th className="py-2 px-4 text-left">Catégorie</th>
                    <th className="py-2 px-4 text-left">Exemples</th>
                    <th className="py-2 px-4 text-left">Source</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-2 px-4">Identité & contact</td>
                    <td className="py-2 px-4">Nom, prénom, adresse e‑mail, pays</td>
                    <td className="py-2 px-4">Formulaire d'inscription (Google Forms/Workspace), compte utilisateur</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Facturation</td>
                    <td className="py-2 px-4">Adresse postale, moyen de paiement (token Stripe)</td>
                    <td className="py-2 px-4">Stripe Checkout</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Données pédagogiques</td>
                    <td className="py-2 px-4">Résultats aux QCM, historique d'accès aux cours et visios</td>
                    <td className="py-2 px-4">Plate‑forme interne</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Données techniques</td>
                    <td className="py-2 px-4">Logs de connexion, type de navigateur, adresse IP tronquée</td>
                    <td className="py-2 px-4">Serveur Heroku, Google Analytics 4 (GA4)</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-gray-600 mb-4">
              Aucune donnée dite « sensible » (origine ethnique, santé, etc.) n'est requise.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Pourquoi les utilisons‑nous ? (Finalités & bases légales)</h2>
            <div className="overflow-x-auto mb-8">
              <table className="w-full">
                <thead>
                  <tr className="border-b">
                    <th className="py-2 px-4 text-left">Finalité</th>
                    <th className="py-2 px-4 text-left">Base légale RGPD</th>
                    <th className="py-2 px-4 text-left">Détails</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-2 px-4">Création du compte & exécution des formations</td>
                    <td className="py-2 px-4">Exécution d'un contrat (art. 6‑1‑b)</td>
                    <td className="py-2 px-4">Gérer l'accès aux cours, QCM, visios</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Facturation & comptabilité</td>
                    <td className="py-2 px-4">Obligation légale (art. 6‑1‑c / art. L123‑22 C. com.)</td>
                    <td className="py-2 px-4">Émettre factures et justificatifs</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Support & service après‑vente</td>
                    <td className="py-2 px-4">Intérêt légitime (art. 6‑1‑f)</td>
                    <td className="py-2 px-4">Répondre aux questions, assurer la disponibilité</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Mesure d'audience (GA4)</td>
                    <td className="py-2 px-4">Consentement (art. 6‑1‑a)</td>
                    <td className="py-2 px-4">Cookies déposés uniquement après accord</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Prospection électronique</td>
                    <td className="py-2 px-4">Consentement pour non‑clients / Intérêt légitime pour clients actifs</td>
                    <td className="py-2 px-4">Limite de conservation : 3 ans après la fin de la relation</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Combien de temps les conservons‑nous ?</h2>
            <div className="overflow-x-auto mb-8">
              <table className="w-full">
                <thead>
                  <tr className="border-b">
                    <th className="py-2 px-4 text-left">Données</th>
                    <th className="py-2 px-4 text-left">Durée</th>
                    <th className="py-2 px-4 text-left">Référence</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-2 px-4">Compte & historique pédagogique</td>
                    <td className="py-2 px-4">Durée de l'abonnement + 3 ans d'archivage (prospection)</td>
                    <td className="py-2 px-4">Recommandation CNIL</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Factures & écritures comptables</td>
                    <td className="py-2 px-4">10 ans</td>
                    <td className="py-2 px-4">Art. L123‑22 C. com.</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Logs techniques</td>
                    <td className="py-2 px-4">12 mois (sécurité, traçabilité)</td>
                    <td className="py-2 px-4">—</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Cookies Google Analytics</td>
                    <td className="py-2 px-4">13 mois (durée paramétrée dans GA4)</td>
                    <td className="py-2 px-4">—</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Qui a accès à vos données ?</h2>
            <div className="overflow-x-auto mb-8">
              <table className="w-full">
                <thead>
                  <tr className="border-b">
                    <th className="py-2 px-4 text-left">Destinataire / Sous‑traitant</th>
                    <th className="py-2 px-4 text-left">Pays</th>
                    <th className="py-2 px-4 text-left">Garanties</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-2 px-4">Heroku (hébergement)</td>
                    <td className="py-2 px-4">États-Unis</td>
                    <td className="py-2 px-4">DPA + certifications SOC 2 Type II et ISO 27001</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Google Workspace & Forms</td>
                    <td className="py-2 px-4">USA</td>
                    <td className="py-2 px-4">EU‑US Data Privacy Framework / SCC</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Google Analytics 4</td>
                    <td className="py-2 px-4">USA</td>
                    <td className="py-2 px-4">Consentement + IP anonymisées</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Stripe Payments Europe</td>
                    <td className="py-2 px-4">Irlande & USA</td>
                    <td className="py-2 px-4">Chiffrement PCI‑DSS / SCC</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-gray-600 mb-4">
              Aucune donnée n'est vendue ni louée.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. Transferts hors Union européenne</h2>
            <p className="text-gray-600 mb-4">
              Les services Google et Stripe peuvent héberger ou traiter certaines informations aux États‑Unis. Ces transferts sont couverts par :
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>l'EU‑US Data Privacy Framework (décision d'adéquation juillet 2023) ou, le cas échéant,</li>
              <li>les Clauses contractuelles types (SCC) approuvées par la Commission européenne.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Sécurité</h2>
            <p className="text-gray-600 mb-4">
              Nous mettons en œuvre :
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>chiffrement TLS 1.3 de bout en bout ;</li>
              <li>mots de passe hashés (Argon2id) ;</li>
              <li>authentification forte sur les comptes administrateurs ;</li>
              <li>politique de sauvegardes quotidiennes chiffrées ;</li>
              <li>contrôle d'accès basé sur le principe du « moindre privilège ».</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. Cookies & traceurs</h2>
            <div className="overflow-x-auto mb-8">
              <table className="w-full">
                <thead>
                  <tr className="border-b">
                    <th className="py-2 px-4 text-left">Type</th>
                    <th className="py-2 px-4 text-left">Finalité</th>
                    <th className="py-2 px-4 text-left">Consentement ?</th>
                    <th className="py-2 px-4 text-left">Réglage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-2 px-4">Techniques (session, anti‑CSRF)</td>
                    <td className="py-2 px-4">Fonctionnement du site</td>
                    <td className="py-2 px-4">Non (exonérés)</td>
                    <td className="py-2 px-4">Navigateur</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Stripe cookies</td>
                    <td className="py-2 px-4">Sécurité paiement</td>
                    <td className="py-2 px-4">Non (art. 82 LIL)</td>
                    <td className="py-2 px-4">Navigateur</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-4">Google Analytics 4</td>
                    <td className="py-2 px-4">Statistiques anonymisées</td>
                    <td className="py-2 px-4">Oui (bandeau Cookiebot)</td>
                    <td className="py-2 px-4">Lien « Gestion des cookies » bas de page</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 className="text-xl font-semibold mt-8 mb-4">9. Vos droits</h2>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>Accès aux données ;</li>
              <li>Rectification et mise à jour ;</li>
              <li>Effacement (« droit à l'oubli ») ;</li>
              <li>Limitation ou opposition (le cas échéant) ;</li>
              <li>Portabilité (données fournies activement) ;</li>
              <li>Retrait du consentement (prospection, Analytics) ;</li>
              <li>Réclamation auprès de la CNIL (www.cnil.fr) si vous estimez que vos droits ne sont pas respectés.</li>
            </ul>
            <p className="text-gray-600 mb-4">
              Pour exercer vos droits, envoyez un e‑mail à <a href="mailto:loustaletformation@gmail.com"
                                                              className="text-rose-500 hover:text-rose-600">loustaletformation@gmail.com</a> ou
              un courrier à l'adresse postale indiquée ci‑dessus. Un justificatif d'identité pourra être demandé. Nous
              nous engageons à répondre sous 30 jours.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">10. Mises à jour de la politique</h2>
            <p className="text-gray-600 mb-4">
              Nous pouvons modifier la présente politique pour refléter des évolutions légales ou techniques. La version en vigueur est toujours accessible depuis le pied de page du Site. En cas de changement majeur (nouvelles finalités, nouveaux destinataires), nous vous en informerons par e‑mail ou lors de votre prochaine connexion afin de recueillir votre consentement si nécessaire.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">11. Contact</h2>
            <p className="text-gray-600 mb-4">
              Pour toute question sur cette politique ou le traitement de vos données :<br /><br />
              L'oustalet formation<br />
              45 rue haute saint paterne, 36100 ISSOUDUN<br />
              E‑mail : <a href="mailto:loustaletformation@gmail.com" className="text-rose-500 hover:text-rose-600">loustaletformation@gmail.com</a><br/>
              Téléphone : 06 76 44 03 65
            </p>

            <p className="text-gray-600 mt-8">
              En naviguant sur loustaletformation.fr ou en achetant une formation, vous reconnaissez avoir lu la présente politique de confidentialité et en accepter les termes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}